import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  change(event) {
    window.dispatchEvent(
      new CustomEvent("map-display-change", {
        detail: { mode: event.target.value },
      })
    );
  }
}
